<template>
  <div class="login-bg">
    <div class="user-login">
      <div class="login-box">
        <div class="login-left">
          <img :src="loginCoverImage" alt="Young·绒 2026 大赛主视觉" class="login-left__image">
<!--          <h3>欢迎来到艺科美课</h3>-->
<!--          <div class="title">全工艺美术在线教育平台</div>-->
        </div>
        <div class="login-right">
          <div class="content">
            <div class="tabs">
              <div class="tabs-title" v-if="activekey === 0 || activekey === 1 || activekey === 2">
<!--                <span :class="{ 'tabs-active': activekey === 0 }" @click="handleClickLogin(0)">微信登录</span>-->
                <span :class="{ 'tabs-active': activekey === 1 }" @click="handleClickLogin(1)">账号登录</span>
                <span :class="{ 'tabs-active': activekey === 2 }" @click="handleClickLogin(2)">短信登录</span>
                <a-icon type="close" class="close" @click="handleClickClose" />
              </div>

              <span v-if="activekey === 3" :class="{ 'tabs-active': activekey === 3 }">忘记密码
              </span>
              <span v-if="activekey === 4" :class="{ 'tabs-active': activekey === 4 }">注册账号
              </span>
              <a-icon v-if="activekey === 3||activekey === 4" type="close" class="close2" @click="handleClickClose" />
            </div>
            <form action="" class="inp-box">
              <div class="login-top" v-if="activekey === 2">
                <span >验证即登录，未注册则自动创建艺科美刻学习账号</span>
              </div>
              <div class="login-top2" v-else>

              </div>
              <div class="qrcode-login" v-if="activekey === 0" >
                <div id="qrcodeImg" class="img"></div>
                <div class="qrcode-msg">微信扫码即可登录开始学习</div>
              </div>
              <div class="phone-number">
                <input type="number" placeholder="手机号" v-model="params.phone" v-if="activekey === 1 ||activekey === 2 || activekey === 3 || activekey === 4" />
                <span v-if="activekey === 2 || activekey === 3 || activekey === 4" @click="handleGetCode" :class="{ 'disabled': isCounting }">{{ countdownText }}</span>
              </div>

              <input type="number" placeholder="输入验证码"
                v-if="activekey === 2 || activekey === 3 || activekey === 4" v-model="signInParams.captcha"/>

              <div class="user-pwd" v-if="activekey === 1 || activekey === 3 || activekey === 4">
                <input type="password" placeholder="密码" id="password" v-model="signInParams.password"/>
                <img v-if="!isShowPwd" src="@/assets/img/login/pwd-hide.png"
                  class="pwd-icon" @click="handleChangeShowPwd"/>
                <img v-if="isShowPwd" src="@/assets/img/login/pwd-show.png"
                  class="pwd-icon" @click="handleChangeShowPwd"/>
              </div>

            </form>
            <div class="login-btn" @click="handleRegister" v-if="activekey === 4">
              注册
            </div>
            <div class="login-btn" @click="handleLogin" v-else-if="activekey === 1">登录</div>
            <div class="login-btn" @click="handleSMSLogin" v-else-if="activekey === 2">登录</div>
            <div class="login-btn3" @click="handleRestPass" v-else-if="activekey === 3">重置密码</div>
            <div class="agreement">
              <em :class="{ isAgree: isAgree }" @click="handleClcikAgree"></em>
              我已同意并阅读
              <span @click="handleClickPrivacy">《隐私政策》</span>
            </div>
            <div class="forget-pwd">
              <span v-if="activekey === 1 || activekey === 2" @click="handleClickLogin(3)" >忘记密码</span>
              <span v-else @click="handleClickLogin(1)">返回登录</span>
              <strong v-if="activekey!=4"></strong>
              <span v-if="activekey!=4" @click="handleClickLogin(4)">快速注册</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { registerVerify, register,restPass,vermobileLogin, login,authLogin } from "@/api/Login";
import dayjs from "dayjs";
import cookie from "@/utils/store/cookie";
import $store from "../../store";
import QRCode from "qrcodejs2";
import graduationAssets from "@/constants/graduationAssets";

const DEFAULT_LOGIN_COVER = graduationAssets.loginImage;

export default {
  name: "Login",
  data() {
    return {
      loginCoverImage: DEFAULT_LOGIN_COVER,
      codes:"11111",
      activekey: 1,
      visible: true,
      oBody: null,
      isShowPwd: false, // 是否显示密码
      isAgree: false, // 是否同意
      params: {
        phone: "",
        type: "register",
      },
      signInParams: {
        account: "",
        captcha: "",
        password: "",
        spread: null,
      },
      smsLoginParams:{
        account:"",
        captcha:""
      },
      loginParams: {
        username: "",
        password: "",
        spread: cookie.get("spread"),
      },
      countdown: 60,      // 倒计时总时长
      timer: null,        // 定时器对象
      isCounting: false   // 是否正在倒计时
    };
  },
  mounted() {
    this.oBody = document.querySelector("body");
    this.syncTabFromRoute();
    // this.qrCode();
  },
  watch: {
    "$route.query.tab": {
      immediate: false,
      handler() {
        this.syncTabFromRoute();
      }
    }
  },
  computed: {
    countdownText() {
      return this.isCounting
          ? `${this.countdown}秒后重新获取`
          : '获取验证码'
    }
  },
  methods: {
    syncTabFromRoute() {
      const tab = Number(this.$route.query.tab);
      if ([0, 1, 2, 3, 4].includes(tab)) {
        this.activekey = tab;
      }
    },
    getBackUrl() {
      const backUrl = cookie.get("login_back_url");
      if (backUrl && backUrl !== "/Login") {
        return backUrl;
      }
      return "/";
    },
    scanLogin(){
      authLogin({}).then(res=>{

      })
    },

    // https://open.weixin.qq.com/connect/oauth2/authorize?appid=你的appid&redirect_uri=你的回调URL&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect
    qrCode() {
      let time = setTimeout(() => {
        document.getElementById("qrcodeImg").innerHTML = "";
        new QRCode(document.getElementById("qrcodeImg"), {
          text: this.codes, // 需要转换为二维码的内容
          width: 160,//二维码的宽度
          height: 160,//二维码的高度
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        clearTimeout(time);
      }, 100);
    },

    handleLogin() {
      if (!this.isAgree) {
        this.$message.error("请同意并阅读《隐私政策》");
        return;
      }
      let signInParams = this.signInParams;
      signInParams.account = this.params.phone;
      if (!this.isMobile(signInParams.account)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      if (!signInParams.password) {
        this.$message.error("请输入密码");
        return;
      }
      this.loginParams.username = this.signInParams.account;
      this.loginParams.password = this.signInParams.password;
      login(this.loginParams)
        .then((res) => {
          console.log("res", res);
          this.$store.commit("LOGIN",  res.data.token, dayjs( res.data.expires_time));
          const backUrl = this.getBackUrl();
          cookie.remove("login_back_url");
          this.$router.replace({path: backUrl});
          this.$store.dispatch("USERINFO")
        })
        .catch((err) => {
          console.log("异常");
          console.log(err);
          this.$message.error(err.data.msg)
        });
    },
    handleSMSLogin(){
      if (!this.isAgree) {
        this.$message.error("请同意并阅读《隐私政策》");
        return;
      }
      let signInParams = this.signInParams;
      signInParams.account = this.params.phone;
      if (!this.isMobile(signInParams.account)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }

      this.smsLoginParams.account = this.signInParams.account;
      this.smsLoginParams.captcha = this.signInParams.captcha;
      vermobileLogin( this.smsLoginParams)
          .then((res) => {
            console.log("res", res);
            if(res.status===200){
              this.$store.commit("LOGIN",  res.data.token, dayjs( res.data.expires_time));
              const backUrl = this.getBackUrl();
              cookie.remove("login_back_url");
              this.$router.replace({path: backUrl});
              this.$store.dispatch("USERINFO")
            }else{
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.data.msg)
          });
    },

    handleRestPass(){
      if (!this.isAgree) {
        this.$message.error("请同意并阅读《隐私政策》");
        return;
      }
      let signInParams = this.signInParams;
      signInParams.account = this.params.phone;
      if (!this.isMobile(signInParams.account)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      if (!signInParams.password) {
        this.$message.error("请输入密码");
        return;
      }
      restPass( this.signInParams)
          .then((res) => {
            console.log("res", res);
            if(res.status===200){
              // this.$store.commit("LOGIN",  res.data.token, dayjs( res.data.expires_time));
              // const backUrl = cookie.get("login_back_url") || "/";
              // cookie.remove("login_back_url");
              // this.$router.replace({path: backUrl});
              // this.$store.dispatch("USERINFO")
              this.$message.success(res.msg)
              this.handleClickLogin(1)
            }else{
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.data.msg)
          });
    },
    handleRegister() {
      if (!this.isAgree) {
        this.$message.error("请同意并阅读《隐私政策》");
        return;
      }
      let signInParams = this.signInParams;
      signInParams.account = this.params.phone;
      if (!this.isMobile(signInParams.account)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      if (!signInParams.captcha) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!signInParams.password) {
        this.$message.error("请输入密码");
        return;
      }
      let params = JSON.parse(JSON.stringify(signInParams));
      register(params)
        .then((res) => {
          console.log("xx", res);
          if (res.status === 200) {
            this.$message.success(res.msg);
            this.handleClickLogin(1);
          } else {
            this.$message.error(res.msg);
            return;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.data.msg)
        });
    },
    isMobile(value) {
      return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value);
    },
    getCode() {
      if (!this.isMobile(this.params.phone)) {
        this.$message.error("请输入正确的手机号码");
        return;
      } else {
        registerVerify(this.params)
          .then((res) => {
            console.log(res);
            if(res.status===200){
              this.$message.success("短信发送成功！");
            }else{
              this.$message.warning(res.msg);
            }

          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.data.msg)
          });
      }
    },
    handleChangeShowPwd() {
      this.isShowPwd = !this.isShowPwd;
      let pwdEle = document.querySelector("#password");
      console.log("pwd", this.pwdEle);
      if (this.isShowPwd) {
        pwdEle.setAttribute("type", "text");
      } else {
        pwdEle.setAttribute("type", "password");
      }
    },

    handleClickLogin(index) {
      if (this.activekey === index) return;
      console.log("xx");
      if(index===0) this.qrCode()
      if (index===2||index===3) this.params.type='login'
      this.isAgree = false;
      this.activekey = index;
    },
    handleClickClose() {
      const backUrl = this.getBackUrl();
      this.$router.push({
        path: backUrl,
      });
    },
    show() {
      this.visible = true;
      this.oBody.style.overflow = "hidden";
    },
    handleClickPrivacy() {
      this.$router.push({name:"RegisterAgreement"})
    },
    handleClcikAgree() {
      this.isAgree = !this.isAgree;
    },
    handleGetCode() {
      // 防止重复点击
      if (this.isCounting) return
      // 执行获取验证码逻辑
      this.getCode()
      // 开始倒计时
      this.startCountdown()
    },
    // 开始倒计时
    startCountdown() {
      this.isCounting = true
      this.countdown = 60

      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.stopCountdown()
          return
        }
        this.countdown--
      }, 1000)
    },

    // 停止倒计时
    stopCountdown() {
      clearInterval(this.timer)
      this.timer = null
      this.isCounting = false
      this.countdown = 60
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
};
</script>

<style lang="scss">
.login-bg{
  height: 700px;
}
.user-login {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .login-box {
    width: 678px;
    height: 402px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 10px;
    .login-left{
      width: 278px;
      height: 402px;
      border-radius: 10px 0 0 10px;
      overflow: hidden;
      background: #0b63bd;

      .login-left__image {
        display: block;
        width: 100%;
        height: auto;
      }

      h3{
        font-size: 30px;
        color: #ffffff;
      }
      .title{
        margin-top:10px;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
      }
    }
    .login-right{
      width: 400px;
      padding: 20px 30px;
      .content {
        width: 100%;
        height: 100%;

        color: #333;
        .tabs {
          margin-bottom: 10px;
          user-select: none;
          .tabs-title{

          }
          span {
            display: inline-block;
            margin-right: 32px;
            line-height: 29px;
            // border-bottom: 2px solid red;
            color: #7f7f7f;
            font-size: 18px;
            cursor: pointer;
          }
          .close {
            font-size: 17px;
            color: #333333;
            top: 14px;
            right:0px;
            margin-left:110px;//临时屏蔽扫码登录会引起位置
          }
          .close2 {
            font-size: 17px;
            color: #333333;
            top: 14px;
            right:0px;
            margin-left:210px;//临时屏蔽扫码登录会引起位置
          }
          .tabs-active {
            color: #da514e;
            position: relative;
            &::after {
              content: "";
              width: 16px;
              height: 2px;
              background-color: #da514e;
              position: absolute;
              left: 23px;
              bottom: -2px;
            }
          }
        }
        .inp-box {
          input {
            padding: 0;
            margin-bottom: 20px;
            width: 340px;
            height: 46px;
            border: 1px solid #DDDDDD;
            border-radius: 5px;
            background-color: transparent;
            color: #333;
            text-indent: 14px;
          }
          .qrcode-login{
            margin-top: 40px;
            //text-align: center;
            .img{
              width: 180px;
              border: #dddddd 1px solid;
              border-radius: 5px;
              margin:0 auto;
              padding: 10px;
            }
            .qrcode-msg{
              text-align: center;
              margin-top: 10px;
            }
          }
          .login-top{
              height: 30px;
              line-height: 30px;
            margin-top: 6px;
              margin-bottom: 4px;
              font-size: 14px;
              color: #7f7f7f;
          }
          .login-top2 {
            height: 15px;
          }
          .phone-number {
            width: 340px;
            position: relative;
            span {
              position: absolute;
              top: 15px;
              right: 10px;
              color: #666666;
              font-size: 16px;
              cursor: pointer;
              user-select: none;
            }
          }
          .user-pwd {
            position: relative;
            .pwd-icon {
              width: 18px;
              height: 18px;
              position: absolute;
              right: 35px;
              top: 12px;
            }
          }

          input::-webkit-input-placeholder {
            font-size: 16px;
            color: #999999;
          }
        }
        .login-btn {
          width: 340px;
          height: 46px;
          line-height: 46px;
          background: #df7645;
          border-radius: 8px;
          text-align: center;
          color: #fff;
          font-size: 16px;
          user-select: none;
          letter-spacing: 21px;
        }
        .login-btn3 {
          width: 340px;
          height: 46px;
          line-height: 46px;
          background: #df7645;
          border-radius: 8px;
          text-align: center;
          color: #fff;
          font-size: 16px;
          user-select: none;
          letter-spacing: 5px;
        }
        .agreement {
          margin: 20px 0 20px;
          color: #92989e;
          font-size: 13px;
          text-align: center;
          user-select: none;
          em {
            display: inline-block;
            width: 10px;
            height: 10px;
            border: 1px solid #aaa;
            &.isAgree {
              border-color: #da514e;
              background: url("../../assets/img/login/tick.svg") no-repeat center center;
              background-size: 8px 8px;
            }
          }
          span {
            color: #447bdf;
            cursor: pointer;
          }
        }
        .forget-pwd {
          margin-bottom: 16px;
          text-align: center;
          font-size: 13px;
          color: #da514e;
          span {
            cursor: pointer;
            user-select: none;
          }
          strong {
            display: inline-block;
            width: 1px;
            height: 11px;
            background-color: #92989e;
            margin: -1px 8px;
          }
        }
      }
    }

  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}

@media (max-width: 900px) {
  .login-bg {
    min-height: 100vh;
    height: auto;
  }

  .user-login {
    padding: 16px;
    align-items: center;
    overflow-y: auto;

    .login-box {
      width: 100%;
      max-width: 420px;
      height: auto;
      min-height: 0;
      display: block;
      border-radius: 14px;
      overflow: hidden;

      .login-left {
        display: none;
      }

      .login-right {
        width: 100%;
        padding: 22px 18px 24px;

        .content {
          .tabs {
            margin-bottom: 14px;

            .tabs-title {
              display: flex;
              align-items: center;
            }

            span {
              margin-right: 22px;
              font-size: 17px;
            }

            .close,
            .close2 {
              margin-left: auto;
              line-height: 29px;
            }
          }

          .inp-box {
            input {
              width: 100%;
              height: 44px;
              margin-bottom: 16px;
            }

            .login-top {
              height: auto;
              min-height: 28px;
              line-height: 1.5;
            }

            .phone-number {
              width: 100%;

              input {
                padding-right: 112px;
              }

              span {
                top: 13px;
                right: 10px;
                max-width: 108px;
                overflow: hidden;
                text-align: right;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 13px;
              }
            }

            .user-pwd .pwd-icon {
              right: 14px;
            }
          }

          .login-btn,
          .login-btn3 {
            width: 100%;
            height: 44px;
            line-height: 44px;
          }

          .agreement {
            margin: 18px 0;
            line-height: 1.6;
          }

          .forget-pwd {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
